
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import Header from "@/components/Header";
import PullToRefreshIndicator from "@/components/PullToRefreshIndicator";
import { addLog } from "@/logger";
import { usePullToRefresh } from "@/hooks/use-pull-to-refresh";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Simple pull to refresh that just navigates home
  const pullToRefresh = usePullToRefresh({
    onRefresh: async () => {
      navigate("/");
    },
  });

  useEffect(() => {
    addLog(
      `404 Error: User attempted to access non-existent route: ${location.pathname}`
    );
  }, [location.pathname]);

  const goHome = () => {
    navigate("/");
  };

  return (
    <div ref={pullToRefresh.containerRef} className="min-h-screen flex flex-col bg-background overflow-auto">
      <PullToRefreshIndicator
        isVisible={pullToRefresh.shouldShowIndicator}
        isRefreshing={pullToRefresh.isRefreshing}
        pullDistance={pullToRefresh.pullDistance}
      />
      
      <Header title="Page Not Found" showBackButton />

      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
        <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6">
          <AlertTriangle className="w-10 h-10 text-amber-600" />
        </div>

        <h1 className="text-3xl font-bold mb-2">Page Not Found</h1>
        <p className="text-muted-foreground mb-6 max-w-md">
          Sorry, we couldn't find the page you're looking for:
          <span className="font-medium block mt-1 text-foreground">
            {location.pathname}
          </span>
        </p>

        <Button onClick={goHome} size="lg" className="min-w-40">
          Return to Home
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
